import { render, staticRenderFns } from "./department-category.vue?vue&type=template&id=528f8800&"
import script from "./department-category.vue?vue&type=script&lang=js&"
export * from "./department-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports